export default "__VITE_ASSET__Dcb9xcOr__"